// -*- coding: utf-8 -*-
import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function RoleFilter({ value, options, onChange, fullWidth = true, color, size = 'small', sx }) {
  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={value}
      onChange={(_, v) => {
        if (v) onChange(v);
      }}
      fullWidth={fullWidth}
      color={color}
      sx={sx}
    >
      {options.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value} sx={{ textTransform: 'none', px: 1.5 }}>
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
